export default {
    data: () => ({
        orderColumnsMobile: [
            {
                label: "start date",
                field: "start_lending_at",
                required: true,
                type: 'date'
            }, {
                label: "consumer first name",
                field: "firstname",
                sortable: true,
                required: true
            }, {
                label: "order status",
                field: "order_status.description",
                required: true,
                sortable: true
            }, {
                label: "codentify",
                field: "lending_kit.codentify",
                required: true
            }, {
                label: "lending point",
                field: "lending_point.description",
                required: true
            }, /*{
                label: "last name",
                field: "lastname",
                sortable: true
            },*/{
                label: "id",
                field: "id",
                sortable: true,
                collapsibleLabel: true
            }, {
                label: "order date",
                field: "created_at",
                sortable: true,
            },{
                label: "lending end date",
                field: "end_lending_at",
                collapsibleSubLabel: true
            },/* {
                label: "birth date",
                field: "birthdate",
                sortable: true
            }, {
                label: "gender",
                field: "gender",
                sortable: true
            }, {
                label: "cell phone",
                field: "phone",
                sortable: true
            }, {
                label: "email",
                field: "email",
                sortable: true
            }, */{
                label: "delivery",
                field: "delivery"
            }, {
                label: "is sold",
                field: "is_sold"
            },/* {
                label: "no sold reason",
                field: "no_sold_reason.description"
            }, */{
                label: "lending real end date",
                field: "real_end_lending_at"
            },{
                label: "address",
                field: "address"
            }, {
                label: "address 2",
                field: "address_2"
            }, {
                label: "zip code",
                field: "zipcode"
            }, {
                label: "city",
                field: "city"
            },/* {
                label: "contact coming from",
                field: "origin.description"
            },*/ {
                label: "follow up",
                field: "follow_up",
                sortable: true,
                align: "center"
            },/* {
                label: "referer",
                field: "referer"
            }, {
                label: "observations",
                field: "observations"
            },*/
            {
                label: "partner",
                field: "partner.name"
            },
        ],
        orderTabFilters: window.config.orderStatusesTab,
        orderListTabs: window.config.orderListTabs,
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/orderColumnsMobile.js